<template>
  <div>
    <header class="section__header">
      <h1 class="section__title" style="margin: 60px 20px;">Client Preview</h1>
    </header>
    <br>
    <section v-if="format && getSizes">
      <section class="demo__adview" :style="{width: computeWidth(size)}" style="margin: 200px auto;" v-for="size in getSizes">
        <h2 class="demo__adtitle" style="color: white;">{{ getDisplaySize(size) }} - Preview</h2>
        <ins class='parkave-placement' :style="'position:relative;display:inline-table;width:'+size.width+'px;height:'+size.height+'px;max-width:100%;'"
             :data-parkave-width='size.width'
             :data-parkave-height='size.height'
             :data-parkave-placement='placement_id'
             :data-parkave-timestamp='getAdTimeStamp'
             :data-parkave-size='size.type'
             :data-parkave-config='config(size)'>
        </ins>
        <h2 class="demo__adtitle" style="color: white;">{{ getDisplaySize(size) }} - Code</h2>
        <div class="export__input export__input--client input">
          <textarea ref="code" readonly class="input__field--dark input__field" :value="getAdCode(size)">
          </textarea>
        </div>
      </section>
    </section>
    <h2 v-if="format && !getSizes" class="demo__adtitle" style="color: white;">Out of Page</h2>
    <section v-if="format && !getSizes" class="window__preview" style="width: 100%; height: 500px;">
      <div class="window__preview__inner">
        <preview-settings :ad="{}" :inputs="{}"></preview-settings>
        <ins class='parkave-placement' style='display:none'
             :data-parkave-placement='placement_id'
             data-parkave-size='out-of-page'
             :data-parkave-timestamp='getAdTimeStamp'
             data-parkave-config='{}'>
        </ins>
      </div>
    </section>
  </div>
</template>

<script>
  import store from '../store.js'
  import PreviewSettings from './common/PreviewSettings';

  export default {
    name: 'ClientPreview',
    data () {
      return {
        placement_id: '',
        format: {},
        format_id: 0
      }
    },
    components: {
      PreviewSettings
    },
    mounted () {
      let s = document.createElement('script');
      s.src = 'https://cdn.getparkave.com/go-sell.js';
      document.body.insertBefore(s, document.body.firstChild);

      if (this.$route.query) {
        this.placement_id = this.$route.query.placement_id;
        this.format_id = this.$route.query.format_id;

        store.dispatch('formats/load').then(formats => {
          formats.forEach(format => {
            if (format.id == this.format_id) {
              this.format = format;
            }
          })
        })
      }
    },
    methods: {
      getDisplaySize(size) {
        if (size.type == 'fixed') {
          return size.width + 'x' + size.height;
        } else {
          return size.width + ':' + size.height;
        }
      },
      config (size) {
        return JSON.stringify({
          size: {
            width: size.width,
            height: size.height,
            type: size.type
          }
        })
      },
      computeWidth (size) {
        if (size.type === 'fixed') {
          return size.width + 'px'
        } else {
          return 'auto'
        }
      },
      getAdCode (size) {
        let parkaveTag = `<!--\n` +
          `+-+-+-+-+-+-+-+ +-+-+-+-+ +-+-+-+-+-+ \n` +
          `|P|a|r|k|A|v|e| |W|i|n|s| |S|a|l|e|s| \n` +
          `+-+-+-+-+-+-+-+ +-+-+-+-+ +-+-+-+-+-+ \n` +
          `Thank you for using ParkAve. Only modify this code if ` +
          `you feel comfortable doing so. \n Email questions to: \n` +
          `parkave-help@broadstreetads.com \n` +
          `--> \n`;
        let gosell = '<scr' + 'ipt src="https://cdn.getparkave.com/go-sell.js"></scr' + 'ipt>';
        let rtnString = `<ins class="parkave-placement" style="position:relative;display:inline-table;width:` + size.width + `px;height:` + size.height + `px;max-width:100%;" ` +
          `data-parkave-width='` + size.width + `' ` +
          `data-parkave-height='` + size.height + `' ` +
          `data-parkave-placement='` + this.placement_id + `' ` +
          `data-parkave-timestamp='` + this.getAdTimeStamp + `' ` +
          `data-parkave-size='` + size.type + `' ` +
          `data-parkave-config='` + this.config(size) + `' ` +
          `data-parkave-click-tracker='%%CLICK_URL_UNESC%%'>` + gosell +
          `</ins>`
        return parkaveTag + rtnString
      }
    },
    computed: {
      getSizes () {
        if (this.format.id) {
          let sizes = [];
          let input = JSON.parse(this.format.specification).inputs;
          for (var i = 0; i < input.length; i++) {
            if (input[i].type === 'size') {
              for (var v = 0; v < input[i].options.length; v++) {
                if (input[i].options[v].type === 'flexible') {
                  sizes.push({
                    width: input[i].options[v].width,
                    type: 'flexible',
                    height: input[i].options[v].height
                  })
                } else {
                  sizes.push({
                    width: input[i].options[v].width,
                    type: 'fixed',
                    height: input[i].options[v].height
                  })
                }
              }
              return sizes;
            }
          }
          if (sizes === []) {
            return null;
          }
        }
        return {};
      },
      getAdTimeStamp () {
        let d = new Date()
        d.setMinutes(0)
        d.setSeconds(0)
        let ts = d.setMilliseconds(0)
        return ts
      }
    }
  }
</script>

<style scoped>
  .export__input--client {
    width: 500px;
    transform: translateX(-50%);
    left: 50%;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/ClientPreview.vue